import { render, staticRenderFns } from "./boss.vue?vue&type=template&id=e210dbf2&scoped=true"
import script from "./boss.vue?vue&type=script&lang=js"
export * from "./boss.vue?vue&type=script&lang=js"
import style0 from "./boss.vue?vue&type=style&index=0&id=e210dbf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e210dbf2",
  null
  
)

export default component.exports